module.exports = __webpack_public_path__ + "static/media/gopika_g.066c2d3f.jpg";